import { GRADES, MASTERY_GRADE, type Grade } from './constants';

export const GRADE_LABELS: Record<Grade, string> = {
  A: 'Mastered',
  B: 'Almost there',
  C: 'Learning',
};

export function isMasteryGrade(grade: Grade | null | undefined): boolean {
  return grade === MASTERY_GRADE;
}

/** Position in GRADES (C = 0 … A = 2); -1 for no grade. */
export function gradeRank(grade: Grade | null | undefined): number {
  return grade ? GRADES.indexOf(grade) : -1;
}

export type GradeChange = 'new' | 'raised' | 'lowered' | 'unchanged';

export function gradeChange(previous: Grade | null | undefined, next: Grade): GradeChange {
  if (!previous) return 'new';
  const diff = gradeRank(next) - gradeRank(previous);
  return diff > 0 ? 'raised' : diff < 0 ? 'lowered' : 'unchanged';
}
